var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef } from 'react';
import { isBrowser } from "../util/const.js";
// eslint-disable-next-line import/no-cycle
import { basicDepsComparator } from "../util/misc.js";
/**
 * Like `useEffect` but uses provided comparator function to validate dependency changes.
 *
 * @param callback Function that will be passed to underlying effect hook.
 * @param deps Dependencies list, like for `useEffect` hook.
 * @param comparator Function that compares two dependencies arrays, and returns true in case
 * they're equal.
 * @param effectHook Effect hook that will be used to run callback. Must comply `useEffect`
 * signature, meaning that callback should be placed as first argument and dependencies list
 * as second.
 * @param effectHookRestArgs Extra arguments that passed to effectHook.
 */
export function useCustomCompareEffect(callback, deps, comparator, effectHook) {
    if (comparator === void 0) { comparator = basicDepsComparator; }
    if (effectHook === void 0) { effectHook = useEffect; }
    var effectHookRestArgs = [];
    for (var _i = 4; _i < arguments.length; _i++) {
        effectHookRestArgs[_i - 4] = arguments[_i];
    }
    var dependencies = useRef();
    // Effects not working in SSR environment therefore no sense to invoke comparator
    if (dependencies.current === undefined ||
        (isBrowser && !comparator(dependencies.current, deps))) {
        dependencies.current = deps;
    }
    effectHook.apply(void 0, __spreadArray([callback, dependencies.current], effectHookRestArgs, false));
}
